import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { useVoice } from './VoiceContext';

/**
 * Small phone icon next to a number on a student or teacher card. Opens the softphone with the number and
 * the student pre-filled. Renders nothing for admins who cannot call.
 */
const CallButton = ({ number, student, teacher, contactLabel, size = 'small' }) => {
    const voice = useVoice();
    if (!voice?.canCall || !number) return null;
    const label = contactLabel === 'teacher' ? 'Call teacher' : contactLabel === 'student' ? 'Call student' : contactLabel === 'parent_2' ? 'Call parent (2nd)' : 'Call parent';
    return (
        <Tooltip title={voice.busy ? 'A call is in progress' : label}>
            <span>{/* a disabled button cannot carry the tooltip's listeners; the span can */}
                <IconButton
                    size={size}
                    onClick={(e) => { e.stopPropagation(); voice.openDialer({ to_number: number, student, teacher, contact_label: contactLabel }); }}
                    sx={{ ml: 0.5, p: 0.25 }}
                    disabled={voice.busy}
                >
                    <PhoneOutlinedIcon sx={{ fontSize: 16 }} />
                </IconButton>
            </span>
        </Tooltip>
    );
};

export default CallButton;
